module.exports = __webpack_public_path__ + "media/images/p1-ed026d89685c9dbf8fd954d59ef256a7.jpg";